import React from "react";
import { TextField, Button, CircularProgress } from "@material-ui/core";

//css
import ModalHeaderCss from "./ModalHeader-Css";
const useStyles = ModalHeaderCss();

export default (props) => {
    const classes = useStyles();
    return (
        <form className={classes.container} noValidate autoComplete="off">
            <div>
                {!props.state.oneClick && (
                    <TextField
                        variant={"filled"}
                        id="standard-name"
                        label="Descrição"
                        className={classes.textField}
                        InputProps={{
                            className: classes.multilineColor,
                        }}
                        onKeyPress={(ev) => {
                            if (ev.key === "Enter") {
                                props.validacao();
                            }
                        }}
                        margin="normal"
                        onChange={(e) => {
                            props.setState({ nm_org: e.target.value });
                        }}
                        value={props.state.nm_org}
                    />
                )}
                {props.state.oneClick && (
                    <div align="center">
                        <CircularProgress />
                    </div>
                )}
            </div>

            <div className={classes.buttonAction} align="right">
                <Button
                    className={classes.buttonCancelar}
                    disabled={props.state.oneClick}
                    onClick={() => {
                        props.setState({ oneClick: true });
                        props.props.router.goBack();
                    }}
                >
                    {"Cancelar"}
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    disabled={props.state.oneClick}
                    onClick={() => {
                        props.validacao();
                    }}
                >
                    {"Salvar"}
                </Button>
            </div>
            <br />
        </form>
    );
};
